<template>
  <div>
    <div class="card-content has-background-table-second-color">
      <div class="columns is-vcentered is-multiline">
        <div class="column is-narrow">
          <b-checkbox v-model="ligneCommande.selectedLogistique">
          </b-checkbox>
        </div>
        <div class="column is-2">
          <p class="has-text-weight-bold is-size-5">{{ ligneCommande.libelle }}</p>
          <p
            class="has-text-default is-size-7"
            v-html="formatBackToLineHtml(ligneCommande.lignesCommande[0].libelle)">
          </p>
          <p class="has-text-default is-size-7" v-if="ligneCommande.parution">
            {{ $t('editionCommande.logistique.parutionInfo', {
                code: ligneCommande.parution.nomParution,
                date: getDate(ligneCommande.parution.dateParution),
              }) }}
          </p>
          <p v-if="ligneCommande.parution">
            <router-link-blank
              :to="{ name: 'm.presse.parution-bat',
              params: { parutionId: ligneCommande.parution.id }}"
              :message="$t('editionCommande.logistique.gestionBat')">
            </router-link-blank>
          </p>
          <p v-if="ligneCommande.parution">
            <router-link-blank
              :to="{ name: 'm.presse.chemin_fer',
              params: { parutionId: ligneCommande.parution.id }}"
              :message="$t('editionCommande.logistique.gestionCheminFer')">
            </router-link-blank>
          </p>
        </div>
        <div class="column is-narrow">
          <p>
            <b-checkbox v-model="ligneCommande.visuelDemande" class="mgt-7px" :disabled="readOnly">
              <span class="label">{{ $t('editionCommande.logistique.visuelDemande') }}</span>
            </b-checkbox>
          </p>
          <p>
            <b-checkbox v-model="ligneCommande.afficheLivre" class="mgt-7px" :disabled="readOnly">
              <span class="label">{{ $t('editionCommande.logistique.visuelRecu') }}</span>
            </b-checkbox>
          </p>
          <p>
            <b-checkbox v-model="ligneCommande.batRepasse" class="mgt-7px" :disabled="readOnly">
              <span class="label">{{ $t('editionCommande.logistique.batRepasse') }}</span>
            </b-checkbox>
          </p>
        </div>
        <div class="column is-narrow">
          <div class="columns is-vcentered">
            <div class="column is-narrow">
              <span class="label">{{ $t('editionCommande.logistique.etatBat') }}</span>
              <b-select v-model="ligneCommande.etatBat" expanded :disabled="readOnly">
                <option :key="etat.key"
                        :value="etat.key"
                        v-for="etat in etatBat">
                  {{ $t(etat.libelle) }}
                </option>
              </b-select>
            </div>
          </div>
        </div>
        <div class="column is-narrow">
          <div class="columns is-vcentered">
            <div class="column is-narrow">
              <span class="label">{{ $t('editionCommande.logistique.dateEnvoie') }}</span>
              <b-datepicker show-week-number
                            :disabled="readOnly"
                            nearby-selectable-month-days
                            v-model="ligneCommande.dateBatDemande"
                            icon="calendar-today"
                            :editable="true">
              </b-datepicker>
            </div>
          </div>
        </div>
        <div class="column is-3-fullhd">
          <b-field :label="$t('editionCommande.logistique.instructionPose')">
            <b-input :disabled="readOnly"
                     type="textarea" :disable="readOnly"
                     v-model="ligneCommande.instructionPose" :rows="1">
            </b-input>
          </b-field>
        </div>
        <div class="column is-narrow">
          <div class="columns is-vcentered">
            <div class="column is-narrow">
              <span class="label">{{ $t('editionCommande.logistique.dateBatCreation') }}</span>
              <b-datepicker
                v-model="ligneCommande.dateBatCreation"
                :disabled="readOnly"
                :editable="true"
                icon="calendar-today"
                nearby-selectable-month-days
                show-week-number>
              </b-datepicker>
              <p>
                <b-checkbox v-model="ligneCommande.batCree" class="mgt-7px" :disabled="readOnly">
                  <span class="label">{{ $t('general.fait') }}</span>
                </b-checkbox>
              </p>
            </div>
          </div>
        </div>
        <div class="column is-narrow">
          <div class="columns is-vcentered">
            <div class="column is-narrow">
              <span class="label">{{ $t('editionCommande.logistique.dateBatModification') }}</span>
              <b-datepicker
                v-model="ligneCommande.dateBatModification"
                :disabled="readOnly"
                :editable="true"
                icon="calendar-today"
                nearby-selectable-month-days
                show-week-number>
              </b-datepicker>
              <p>
                <b-checkbox v-model="ligneCommande.batModifie" class="mgt-7px" :disabled="readOnly">
                  <span class="label">{{ $t('general.fait') }}</span>
                </b-checkbox>
              </p>
            </div>
          </div>
        </div>
        <div class="column is-narrow">
          <div class="columns is-vcentered">
            <div class="column is-narrow">
              <span class="label">{{ $t('editionCommande.logistique.dateBatFormat') }}</span>
              <b-datepicker
                v-model="ligneCommande.dateBatFormat"
                :disabled="readOnly"
                :editable="true"
                icon="calendar-today"
                nearby-selectable-month-days
                show-week-number>
              </b-datepicker>
              <p>
                <b-checkbox v-model="ligneCommande.batFormat" class="mgt-7px" :disabled="readOnly">
                  <span class="label">{{ $t('general.fait') }}</span>
                </b-checkbox>
              </p>
            </div>
          </div>
        </div>
        <div v-if="this.$route.params.id" class="column is-narrow">
          <ligne-commande-attachement
              class="mgh-20px"
              :id="ligneCommande.id"
              :context="constantes.module"
              :libelleImage="$t('editionCommande.logistique.libelleLogo',
                                  { name: this.ligneCommande.libelle })"
              :permissions="constantes.permCommande.lecture"
              :resizeFile="false">
          </ligne-commande-attachement>
        </div>
        <div class="column is-narrow">
          <div class="columns is-vcentered">
            <div class="column is-narrow">
              <button
                class="button is-addOrEdit"
                :disabled="!this.$route.params.id"
                @click="edition({
                  format: constantes.pdf,
                  typeDonnee: constantes.typeEditionBat
                })">
                {{ $t('editionCommande.logistique.editionBat') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import edition from '@/api/edition/index';
import { ETAT_BAT } from '@/configuration/presse/produitPresse/produitPresseConf';
import formatDate from '@/services/general/formatDate';
import messageErreur from '@/services/general/messageErreur';
import validationGeneral from '@/services/validation/validation';
import readErrorBlobRequest from '@/services/edition/readBlobRequest';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import { createNamespacedHelpers } from 'vuex';
import { TYPE_PDF } from '@/configuration/edition/editionConf';
import { TYPE_EDITION_BAT } from '@/configuration/presse/parution/batConfig';
import * as types from '@/store/modules/attachments-mutation-type';
import { MODULE_LIGNE_COMMANDE } from '@/configuration/general/pieceJointeConf';
import formatBackToLineHtml from '@/services/general/formatBackToLineHtml';
import ligneCommandeAttachement from '@/components/commande/logistique/ligneCommandeAttachement';
import { COMMANDES } from '@/configuration/permissionsBodacConf';

const Attachments = createNamespacedHelpers('attachments');

export default {
  name: 'ligneCommandePresse',
  props: {
    ligneCommande: {
      type: Object,
      required: true,
    },
    readOnly: {
      type: Boolean,
      required: false,
    },
  },
  components: {
    routerLinkBlank,
    ligneCommandeAttachement,
  },
  data() {
    return {
      etatBat: ETAT_BAT,
      constantes: {
        pdf: TYPE_PDF,
        typeEditionBat: TYPE_EDITION_BAT,
        module: MODULE_LIGNE_COMMANDE,
        permCommande: COMMANDES,
      },
      errorEdition: {
        haveError: false,
        messages: [],
        champsVide: [],
        messagesChampsVide: [],
      },
      formatBackToLineHtml,
    };
  },
  methods: {
    ...Attachments.mapMutations({
      setLogo: types.SET_LOGO,
    }),
    getDate(dateParution) {
      return formatDate(dateParution);
    },
    async edition(donnees) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.errorEdition.champsVide = [];
        this.errorEdition.messagesChampsVide = [];
        this.errorEdition.messages = [];
        this.errorEdition.haveError = false;
        const response = await edition({
          ids: [this.ligneCommande.id],
          extension: donnees.format,
          typeDonnee: donnees.typeDonnee,
          typeEdition: donnees.typeEdition ? donnees.typeEdition : '',
        });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        loadingComponent.close();
        this.popUpEdition = false;
      } catch (e) {
        if (e.response) {
          const errorResponseString = await readErrorBlobRequest(e.response.data);
          const response = JSON.parse(errorResponseString);
          validationGeneral(this.$i18n, { data: response }, this.errorEdition.champsVide,
            this.errorEdition.messages, this.errorEdition.messagesChampsVide);
          this.errorEdition.haveError = true;
          loadingComponent.close();
          return;
        }
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
  },
};
</script>

<style scoped>

</style>
